// extracted by mini-css-extract-plugin
module.exports = {"header":"pZjCM","logo":"v4gRQ","nav-item":"pEC14"};